import React, { useContext, useEffect, useState } from "react";		//FB 4409 DK - Added useeffect reference
import {
  Grid,
  Avatar,
  Typography,
  makeStyles,
  Link,
  Card,
  CardContent,
  CardMedia,
} from "@material-ui/core";
//import doc from "../../../images/loc.jpg";
//import { Schedule, Provider } from "../../types";
import SlotsContainer from "./SlotsContainer";
import useStyle from "../css/styles";
import { Context } from "../store";
import globalsettings from "../../../config";
import { formatphone, InsertPELogs, GetAdminSettingValue } from "../api";    //FB 4774 DK - Added reference to formatphone method , FB 4960, FB 7418

// update log
// FB 4371 DK    03/29/2021    Added UI component to display the slots container
// FB 4409 DK    04/27/2021    Implementation of loading spinner on slots page
// FB 4409 DK    04/30/2021    Added message to show when all available slots are booked
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 4774 DK    11/12/2021    Modified the messages
// FB 4867 DK    01/20/2022    Phone number made clickable
// FB 4912 DK    01/27/2022    Resolved message error
// FB 4930 DK    01/31/2022    Phone number missing in message
// FB 4960 BR    07/03/2022   Logging all actions on PE
// FB 7418 GS    09/21/2023    Added admin setting to change the message on PE when slots are not available
// FB 7413 GA    09/25/2023    Orady - Update the map link to the correct one
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 7908 SK    01/08/2024    PE Online Appointment Bookings Facility Missing Address 2
// FB 8213 MS    02/08/2024    Fetch the facility image from EMR
// FB 8290 MS    04/29/2024    Show google link only if available in EMR
// FB 8680 DK    05/21/2024    Practice phone related changes



export type Schedule = {
  ScheduleDate: string;
  Slots: string[];
};

export type SchedulesTest = {
  Facility_N: number;
  Facility_Name: string;
  Facility_Address: string;
  Facility_Address2: string;//FB 7908
  Facility_Info: string;
  NextAvailability: string;
  IsInsuranceAccepted: boolean;
  SlotsDate: SlotsDate[];
  Scheduling_Phone: string;
  availableSlotsCount: number;    //FB 4409 DK - Added variable for available slots count
  Duration: number; //FB 4638 added duration field
  GOOGLE_MAPS_LINK: string; //FB 7413
};

export type SlotsDate = {
  ScheduleDate: string;
  Slots: string[];
};

export type Provider = {
  //name: string;
  //id: number;
  //facility: Facility;
  schedulesTest: SchedulesTest[];
};

interface IProviderScheduleRowProps {
  Provider: Provider;
  Limited: number;
  Index: number;
  ProviderId: number;
  ProviderName: string;
  isLoading: any;   //FB 4409 DK - Added isLoading flag to activate loading spinner
}

const useStyles = makeStyles((theme) => ({
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "220px",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  centered: {
    alignSelf: "center",
  },
  content: {
    flex: "1 0 auto",
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  topBarItem: {
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  margin: {
    margin: theme.spacing(1),
  },
  providerRow: {
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    padding: "20px 0",
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    padding: "10px",
    //width: "70%",
    fontSize: "smaller",
    //height: "25px",
  },
}));

function ProviderScheduleRow(props: IProviderScheduleRowProps) {
  const classes = useStyles();
  const styles = useStyle();
  const { state, dispatch } = useContext(Context);
  //FB 7418 Begin
  const [textMessage, setTextMessage] = useState("");
  const [textValue, setTextValue] = useState(false);
  //FB 7418 End
  let Phone = props.Provider.schedulesTest[props.Index].Scheduling_Phone;
  if (Phone != null) {
    Phone = Phone.replace(/[^0-9]/g, "");
  }
  const [disableEvents, setDiableEvents] = useState(false);

  //FB 4409 DK - Added flag for loading spinner
  const [isLoading, setIsLoading] = useState(false);

  //FB 4960 Start
  const insertLogs = async () => {
    InsertPELogs(globalsettings.clientIp, "Click on View Map");
  }
  //FB 4960 End
  const [defaultPhone, setDefaultPhone] = useState(""); //FB 8680

  //FB 7418 Begin
  async function GetSlotsMessage() {
    var data = await GetAdminSettingValue("PE_Slot_Unavailable_Message");
    if (data != "") {
      setTextMessage(data);
      setTextValue(true);
    }
    //FB 8680
    var practicePhone = await GetAdminSettingValue("Default_Sch_Appt_Number");
    if (practicePhone != null) {
      setDefaultPhone(practicePhone);
  }
  }
  //FB 7418 End

  //FB 4409 DK - Added to swap the isLoading flag on slots page when isLoading flag is updated 
  useEffect(() => {
    GetSlotsMessage(); //FB 7418
    props.isLoading(isLoading);
  }, [isLoading])

  //FB 7801 - Begin
  const [sessionAppointment, setSessionAppointment] = React.useState("");

  useEffect(() => {
    const appt = sessionStorage.getItem("AppointmentType");
    setSessionAppointment(appt!);
  }, []);
  //FB 7801 - End

  return props.Provider !== undefined ? (
    <div>
      {window.innerWidth <= 768 ? (
        <div>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="center"
          >
            <Grid item xs={12}>
              <Card
                className={styles.slotslocation_Card}
                style={{ boxShadow: "none" }}
              >
                <CardMedia>
                  {/* FB 8213 - changed src */}
                  <Avatar
                    style={{ marginTop: 5 }}
                    className={styles.slotslocation_Avatar}
                    src={`${globalsettings.emrAPI}media/facilties/${props.Provider.schedulesTest[props.Index].Facility_N}.jpg`}
                  />
                </CardMedia>
                <CardContent>
                  <Typography variant="h6">
                    <b>
                      {props.Provider.schedulesTest[props.Index].Facility_Name}
                    </b>
                  </Typography>
                  <Typography style={{ fontSize: "medium" }}>
                    {props.Provider.schedulesTest[props.Index].Facility_Address}
                  </Typography>
                  {/* FB 7908 - Begin */}
                  <Typography style={{ fontSize: "medium" }}>
                    {props.Provider.schedulesTest[props.Index].Facility_Address2 && (
                      props.Provider.schedulesTest[props.Index].Facility_Address2
                    )}
                  </Typography>
                  {/* FB 7908 - End */}
                  <Typography style={{ fontSize: "medium" }}>
                    {props.Provider.schedulesTest[props.Index].Facility_Info}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "medium",
                      display: "flex",
                      alignContent: "center",
                    }}
                  >
                    {/*FB-4930*/}
                    {formatphone(props.Provider.schedulesTest[props.Index].Scheduling_Phone)}
                  </Typography>
                  <Typography
                    style={{
                      display:
                        state.appointmentdetails.appointmenttype ===
                          "telederm" ||
                          props.Provider.schedulesTest[props.Index]
                            .Facility_Address === "" ||
                          props.Provider.schedulesTest[props.Index]
                            .Facility_Address === null
                          ? "none"
                          : "flex",
                    }}
                  >
                    <Link
                      href={
                        props.Provider.schedulesTest[props.Index].GOOGLE_MAPS_LINK
                      }//FB 7413
                      onClick={insertLogs} //FB 4960
                      target="_blank"
                      style={{
                        display:
                        props.Provider.schedulesTest[props.Index].GOOGLE_MAPS_LINK === "" ||
                        props.Provider.schedulesTest[props.Index].GOOGLE_MAPS_LINK === null
                            ? "none"
                            : "block",
                      }}  //FB 8290
                    >
                      View Map
                    </Link>
                  </Typography>
                  <Typography>{sessionAppointment}</Typography>{/* FB 7801 */}
                  <Typography
                    //variant="subtitle1"
                    style={{
                      color: "red",
                      display:
                        state.appointmentdetails.isInsuranceExist === "No"
                          ? "none"
                          : props.Provider.schedulesTest[props.Index]
                            .IsInsuranceAccepted
                            ? "none"
                            : "inline-flex",
                    }}
                  >
                    This provider does not accept the selected insurance at this
                    location.
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "smaller",
                      color: "red",
                      display:
                        state.appointmentdetails.isInsuranceExist === "No"
                          ? "none"
                          : props.Provider.schedulesTest[props.Index]
                            .IsInsuranceAccepted
                            ? "none"
                            : "inline-flex",
                    }}
                  >
                    (If your insurance plan includes out-of-network coverage,
                    please ignore this warning)
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="center"
            style={{
              display: "flex",
              pointerEvents: disableEvents ? "none" : "auto",
            }}
          >
            {props.Provider.schedulesTest[props.Index].SlotsDate.length ===
              1 ? (
              <Grid
                item
                xs={10}
                style={{ backgroundColor: "lightgray", borderRadius: "16px" }}
              >
                {/* FB 4774 DK - Modified message */}
                {/* FB 4867 */}
                <Typography variant="subtitle2" style={{ textAlign: "center" }}>
                  The next available online appointment for this provider is {props.Provider.schedulesTest[props.Index].NextAvailability}
                  . If you need an appointment sooner, Please call {formatphone(props.Provider.schedulesTest[props.Index].Scheduling_Phone)}.
                </Typography>
              </Grid>
              // FB 4409 DK - Added condition and message to be displayed when there are no available slots - Start
            ) : props.Provider.schedulesTest[props.Index].availableSlotsCount <= 0 ? (
              <Grid
                item
                xs={10}
                style={{ backgroundColor: "lightgray", borderRadius: "16px" }}
              >
                {/*FB-4930 Start*/}
                {props.Provider.schedulesTest[props.Index].NextAvailability != null ?
                  (<Typography variant="subtitle2" style={{ textAlign: "center" }}>
                    {/* FB 4774 DK - Modified message */}
                    {/* FB 4867 */} {/*FB-4912*/}
                    The next available online appointment for this provider is {props.Provider.schedulesTest[props.Index].NextAvailability}
                    . If you need an appointment sooner, Please call  {formatphone(props.Provider.schedulesTest[props.Index].Scheduling_Phone)}.
                  </Typography>
                  ) : (
                    //FB 7418 Begin
                    (!textValue ? (<Typography variant="subtitle2" style={{ textAlign: "center" }}>
                      {/* FB 4774 DK - Modified message */}
                      {/* FB 4867 */} {/*FB-4912*/}
                      There are no online appointments available for this provider. Please call  {formatphone(props.Provider.schedulesTest[props.Index].Scheduling_Phone)} to book an appointment.
                    </Typography>) :
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "center" }}
                      >
                        {/* FB 4774 - Modified the message */}
                        {/* FB 4867 */}
                        {/* FB 8680 */}
                        {props.Provider.schedulesTest[props.Index].Scheduling_Phone.length > 0 ? textMessage.replace("@practice_phone", props.Provider.schedulesTest[props.Index].Scheduling_Phone)
                          : textMessage.replace("@practice_phone", defaultPhone)}
                      </Typography>)
                    //FB 7418 End
                  )}
                {/*FB-4930 End*/}
              </Grid>
            ) : (
              // FB 4409 DK - Added condition and message to be displayed when there are no available slots - End
              <Grid item xs={10} style={{ overflowX: "auto" }}>
                {props.Provider.schedulesTest[props.Index].SlotsDate.map(
                  (ele: SlotsDate, index: number) => (
                    <SlotsContainer
                      limited={props.Limited}
                      schedulesTest={ele}
                      key={index}
                      facilityid={
                        props.Provider.schedulesTest[props.Index].Facility_N
                      }
                      employeeid={props.ProviderId}
                      employeeName={props.ProviderName}
                      facilityName={
                        props.Provider.schedulesTest[props.Index].Facility_Name
                      }
                      facilityAddress={
                        props.Provider.schedulesTest[props.Index]
                          .Facility_Address +
                        ", " +
                        props.Provider.schedulesTest[props.Index].Facility_Info
                      }
                      facilityPhone={
                        Phone != null
                          ? "(" +
                          Phone.slice(0, 3) +
                          ") " +
                          Phone.slice(3, 6) +
                          "-" +
                          Phone.slice(6, 10)
                          : ""
                      }
                      onCallback={setDiableEvents}
                      isLoading={setIsLoading}    //FB 4409 DK - Added to update the isLoading flag on slots page
                      duration={props.Provider.schedulesTest[props.Index].Duration} //FB 4638 added duration field
                    />
                  )
                )}
              </Grid>
            )}
          </Grid>
        </div>
      ) : (
        <Grid
          container
          spacing={3}
          direction="row"
          alignContent="center"
          justify="flex-start"
          style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)", marginTop: 10 }}
        >
          <Grid item xs={4} sm={4} md={4}>
            <Card
              className={styles.slotslocation_Card}
              style={{ boxShadow: "none", alignItems: "center" }}
            >
              <CardMedia>
                {/* FB 8213 - changed src */}
                <Avatar
                  style={{ marginTop: 5 }}
                  className={styles.slotslocation_Avatar}
                  src={`${globalsettings.emrAPI}media/facilties/${props.Provider.schedulesTest[props.Index].Facility_N}.jpg`}
                />
              </CardMedia>
              <CardContent style={{ display: "contents" }}>
                <Typography variant="h6">
                  <b>
                    {props.Provider.schedulesTest[props.Index].Facility_Name}
                  </b>
                </Typography>
                <Typography style={{ fontSize: "medium" }}>
                  {props.Provider.schedulesTest[props.Index].Facility_Address}
                </Typography>
                {/* FB 7908 - Begin */}
                <Typography style={{ fontSize: "medium" }}>
                  {props.Provider.schedulesTest[props.Index].Facility_Address2 && (
                    props.Provider.schedulesTest[props.Index].Facility_Address2
                  )}
                </Typography>
                {/* FB 7908 - End */}
                <Typography style={{ fontSize: "medium" }}>
                  {props.Provider.schedulesTest[props.Index].Facility_Info}
                </Typography>
                <Typography style={{ fontSize: "medium" }}>
                  {/*FB-4930*/}
                  {formatphone(props.Provider.schedulesTest[props.Index].Scheduling_Phone)}
                </Typography>
                <Typography
                  style={{
                    display:
                      state.appointmentdetails.appointmenttype === "telederm" ||
                        props.Provider.schedulesTest[props.Index]
                          .Facility_Address === "" ||
                        props.Provider.schedulesTest[props.Index]
                          .Facility_Address === null
                        ? "none"
                        : "flex",
                  }}
                >
                  <Link
                    href={
                      props.Provider.schedulesTest[props.Index].GOOGLE_MAPS_LINK
                    } //FB 7413
                    onClick={insertLogs} //FB 4960
                    target="_blank"
                    style={{
                      display:
                      props.Provider.schedulesTest[props.Index].GOOGLE_MAPS_LINK === "" ||
                      props.Provider.schedulesTest[props.Index].GOOGLE_MAPS_LINK === null
                          ? "none"
                          : "block",
                    }}  //FB 8290
                  >
                    View Map
                  </Link>
                </Typography>
                <Typography>{sessionAppointment}</Typography>{/* FB 7801 */}
                <Typography
                  //variant="subtitle1"
                  style={{
                    color: "red",
                    display:
                      state.appointmentdetails.isInsuranceExist === "No"
                        ? "none"
                        : props.Provider.schedulesTest[props.Index]
                          .IsInsuranceAccepted
                          ? "none"
                          : "flex",
                  }}
                >
                  This provider does not accept the selected insurance at this
                  location.
                </Typography>
                <Typography
                  style={{
                    fontSize: "smaller",
                    color: "red",
                    display:
                      state.appointmentdetails.isInsuranceExist === "No"
                        ? "none"
                        : props.Provider.schedulesTest[props.Index]
                          .IsInsuranceAccepted
                          ? "none"
                          : "flex",
                  }}
                >
                  (If your insurance plan includes out-of-network coverage,
                  please ignore this warning)
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={6}
            sm={7}
            md={7}
            style={{
              display: "flex",
              pointerEvents: disableEvents ? "none" : "auto",
            }}
            direction="row"
            alignContent="space-around"
            justify="space-around"
          >
            {props.Provider.schedulesTest[props.Index].SlotsDate.length ===
              1 ? (
              <Grid item style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  <div className={classes.timeSlotItem}>
                    <Typography
                      variant="subtitle2"
                      style={{ textAlign: "center" }}
                    >
                      {/* FB 4774 DK - Modified message */}
                      {/* FB 4867 */}
                      The next available online appointment for this provider is {props.Provider.schedulesTest[props.Index].NextAvailability}
                      . If you need an appointment sooner, Please call {formatphone(props.Provider.schedulesTest[props.Index].Scheduling_Phone)} .
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              // FB 4409 DK - Added condition and message to be displayed when there are no available slots - Start
            ) : props.Provider.schedulesTest[props.Index].availableSlotsCount <= 0 ? (
              <Grid item style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  {/*FB-4930 Start*/}
                  {props.Provider.schedulesTest[props.Index].NextAvailability != null ?
                    (<div className={classes.timeSlotItem}>
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "center" }}
                      >
                        {/* FB 4774 DK - Modified message */}
                        {/* FB 4867 */} {/*FB-4912*/}
                        The next available online appointment for this provider is {props.Provider.schedulesTest[props.Index].NextAvailability}
                        . If you need an appointment sooner, Please call  {formatphone(props.Provider.schedulesTest[props.Index].Scheduling_Phone)}.
                      </Typography>
                    </div>) : (<div className={classes.timeSlotItem}>
                      {/* FB 7418 Begin */}
                      {!textValue ? (
                        <Typography
                          variant="subtitle2"
                          style={{ textAlign: "center" }}
                        >
                          {/* FB 4774 DK - Modified message */}
                          {/* FB 4867 */} {/*FB-4912*/}
                          There are no online appointments available for this provider. Please call  {formatphone(props.Provider.schedulesTest[props.Index].Scheduling_Phone)} to book an appointment.
                        </Typography>
                      ) :
                        <Typography
                          variant="subtitle2"
                          style={{ textAlign: "center" }}
                        >
                          {/* FB 4774 - Modified the message */}
                          {/* FB 4867 */}
                          {/* FB 8680 */}
                          {props.Provider.schedulesTest[props.Index].Scheduling_Phone.length > 0 ? textMessage.replace("@practice_phone", props.Provider.schedulesTest[props.Index].Scheduling_Phone)
                            : textMessage.replace("@practice_phone", defaultPhone)}
                        </Typography>
                      }
                      {/* FB 7418 End */}
                    </div>)}
                  {/*FB-4930 End*/}
                </Grid>
              </Grid>
            ) : (
              // FB 4409 DK - Added condition and message to be displayed when there are no available slots - End
              props.Provider.schedulesTest[
                props.Index
              ].SlotsDate.map((ele: SlotsDate, index: number) => (
                <SlotsContainer
                  limited={props.Limited}
                  schedulesTest={ele}
                  key={index}
                  facilityid={
                    props.Provider.schedulesTest[props.Index].Facility_N
                  }
                  employeeid={props.ProviderId}
                  employeeName={props.ProviderName}
                  facilityName={
                    props.Provider.schedulesTest[props.Index].Facility_Name
                  }
                  facilityAddress={
                    props.Provider.schedulesTest[props.Index].Facility_Address +
                    ", " +
                    props.Provider.schedulesTest[props.Index].Facility_Info
                  }
                  facilityPhone={
                    Phone != null
                      ? "(" +
                      Phone.slice(0, 3) +
                      ") " +
                      Phone.slice(3, 6) +
                      "-" +
                      Phone.slice(6, 10)
                      : ""
                  }
                  onCallback={setDiableEvents}
                  isLoading={setIsLoading}    //FB 4409 DK - Added to update the isLoading flag on slots page
                  duration={props.Provider.schedulesTest[props.Index].Duration} //FB 4638 added duartion field
                />
              ))
            )}
          </Grid>
        </Grid>
      )}
    </div>
  ) : (
    <></>
  );
}

export default ProviderScheduleRow;
